// extracted by mini-css-extract-plugin
export default {"container":"Content_container__XCCrS","mb":"Content_mb__KUWHl","textRight":"Content_textRight__OnNf-"};